module.exports = __webpack_public_path__ + "static/media/LH-Logo@3x.566da8f8.png";